import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { api } from "@/lib/api";
import { installAttribution } from "@/lib/attribution";

installAttribution([api]);

// Suppress benign "ResizeObserver loop" warnings (Radix UI + CRA dev overlay)
const _roError = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes(_roError)) {
    e.stopImmediatePropagation();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
